const REFERENCES_DOMAIN = 'references'
const REFERENCES_ACTION = {
  ADD: 'REFERENCES_ADD',
  DELETE: 'REFERENCES_DELETE'
}

const REFERENCES_STATE = {}

export {
  REFERENCES_ACTION,
  REFERENCES_STATE,
  REFERENCES_DOMAIN
}
